import { render, staticRenderFns } from "./PickUpPrepare.vue?vue&type=template&id=a101677c&"
import script from "./PickUpPrepare.vue?vue&type=script&lang=ts&"
export * from "./PickUpPrepare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports